"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const tracker_1 = __importDefault(require("./tracker"));
const service_1 = require("./../backend/service");
const TrackingPlugin = {
    install(Vue, opts) {
        this.router = opts.router;
        this.tracker = tracker_1.default;
        if (opts.config) {
            tracker_1.default.config(opts.config);
        }
        Vue.$tracker = this;
        Vue.prototype.$tracker = this;
        if (this.router) {
            this.router.afterEach(this.pageview.bind(this));
        }
        window.addEventListener('beforeunload', () => {
            tracker_1.default.flush();
        });
    },
    pageview(route) {
        tracker_1.default.track({
            eventType: service_1.EventType.PAGEVIEW,
            eventValue: route.path,
            eventData: this.getEventDataFromRoute(route),
            correlation: this.getCorrelationFromRoute(route)
        });
    },
    action(eventValue, eventData = {}, correlation = {}, flush = false) {
        tracker_1.default.track({
            eventType: service_1.EventType.ACTION,
            eventValue,
            eventData: Object.assign({}, this.getEventDataFromRoute(), eventData),
            correlation: Object.assign({}, this.getCorrelationFromRoute(), correlation)
        }, flush);
    },
    getCorrelationFromRoute(route) {
        const correlation = {};
        if (!route && this.router) {
            route = this.router.currentRoute;
        }
        if (route) {
            if (route.meta && route.meta.analytics) {
                correlation.product = tracker_1.default.normalizeProduct(route.meta.analytics.product);
            }
            if (route.params && route.params.contractId) {
                correlation.contractId = route.params.contractId.toString();
            }
            if (route.params && route.params.depositId) {
                correlation.contractId = route.params.depositId.toString();
            }
        }
        return correlation;
    },
    getEventDataFromRoute(route) {
        const eventData = {};
        if (!route && this.router) {
            route = this.router.currentRoute;
        }
        if (route && route.params) {
            Object.assign(eventData, route.params);
            // Already covered in correlation
            delete eventData.contractId;
            delete eventData.depositId;
        }
        return eventData;
    }
};
exports.default = TrackingPlugin;
